<div class="tw-flex tw-h-full tw-w-full tw-min-w-0 tw-flex-col tw-items-start tw-justify-center">
  <span
    class="card-selected-name tw-w-full tw-text-sm tw-font-semibold tw-text-dt-text-headings tw-text-wrap tw-break-words tw-line-clamp-2"
    [title]="title"
    >{{ title }}</span
  >
  <span class="tw-text-xs tw-font-normal tw-text-dt-text-secondary"
    >{{ transactionCount }}
    {{ (transactionCount === 1 ? "transaction" : "transactions") | i18n }}</span
  >
</div>
